export default "__VITE_ASSET__DKC9DTsw__"